<template>
    <div id="shortlistPage">
        <div class="contentBox">
            <p>征稿申报管理</p>
            <div class="contentFormBox">
                <!-- 上方按钮 -->
                <div>
                    <el-button
                    type="text"
                    size="small"
                    icon="el-icon-download"
                    @click="SourceOut()"
                    >导出</el-button
                    >
                    <el-button
                    type="text"
                    size="small"
                    icon="el-icon-check"
                    @click="preCheck('toOn')"
                    >审核通过</el-button
                    >
                    <el-button
                    type="text"
                    icon="el-icon-close"
                    size="small"
                    @click="preCheck('toOff')"
                    >审核不通过</el-button
                    >
                    <el-button
                    type="text"
                    icon="el-icon-tickets"
                    size="small"
                    @click="preCheck('toIn')"
                    >入选</el-button
                    >
                    <el-button
                    type="text"
                    size="small"
                    icon="el-icon-delete"
                    @click="preCheck('toDelete')"
                    >删除</el-button
                    >
                    <el-button
                    type="text"
                    size="small"
                    icon="el-icon-price-tag"
                    @click="preCheck('toAddMark')"
                    >标记</el-button
                    >
                </div>
                
                <!-- 搜索 -->
                <div class="search-box">
                    <el-form ref="searchFileForm" :model="searchFileForm" label-width="100px">
                    <el-form-item label="标记：">
                        <el-input
                        v-model="searchFileForm.mark"
                        placeholder="请输入标记"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动类型：">
                        <el-select v-model="searchFileForm.actType" clearable placeholder="请选择状态">
                            <el-option value="10" label="待审核"> </el-option>
                            <el-option value="20" label="审核通过"> </el-option>
                            <el-option value="30" label="审核未通过"> </el-option>
                            <el-option value="40" label="入选"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="提交时间：">
                        <el-date-picker
                        v-model="submitTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label-width="0px">
                        <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-search"
                        @click="
                            currentPage = 1;
                            onSearch();
                        "
                        >查询</el-button
                        >
                    </el-form-item>
                    </el-form>
                </div>

                <!-- 主列表 -->
                <el-table
                    :data="submitInfoListData"
                    v-loading="tableLoading"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-customClass="loadingStyles"
                    style="width: 100%"
                    class="maintable"
                    border
                    :header-cell-style="{ background: '#f8f8f8' }"
                    @selection-change="handleTableSelectionChange"
                >
                    <el-table-column
                    type="selection"
                    min-width="55"
                    align="center"
                    ></el-table-column>
                    <el-table-column
                    prop="actName"
                    min-width="80"
                    label="征稿活动名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="series"
                    show-overflow-tooltip
                    label="所属系列"
                    min-width="70px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <span effect="dark" v-if="scope.row.status == '人文社科系列'"
                        >人文社科系列</span>
                        <span effect="dark" v-if="scope.row.status == '科学技术系列'"
                        >科学技术系列</span>
                    </template>
                    </el-table-column
                    >
                    <el-table-column
                    prop="subject"
                    show-overflow-tooltip
                    label="所属学科"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column
                    >
                    <el-table-column
                    prop="name"
                    show-overflow-tooltip
                    label="成果名称"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="applyName"
                    show-overflow-tooltip
                    label="申请人"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="workUnit"
                    show-overflow-tooltip
                    label="所在单位"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="addTime"
                    show-overflow-tooltip
                    label="提交日期"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="mark"
                    show-overflow-tooltip
                    label="标记"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="status"
                    show-overflow-tooltip
                    label="审核状态"
                    min-width="70px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <span effect="dark" v-if="scope.row.status == 10"
                        >待审核</span>
                        <span style="color: green;" v-if="scope.row.status == 20"
                        >审核通过</span>
                        <span effect="dark" v-if="scope.row.status == 30"
                        >审核未通过</span>
                        <span effect="dark" v-if="scope.row.status == 40"
                        >入选</span>
                    </template>
                    </el-table-column
                    >
                    <el-table-column
                    show-overflow-tooltip
                    label="操作"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <span
                        class="right-add-button"
                        style="display: block"
                        @click="preview(scope.row)"
                        >【预览】</span
                        >
                    </template>
                </el-table-column>
                </el-table>
                <!-- 主列表分页 -->
                <div class="pagination-box">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize"
                    >
                    </el-pagination>
                </div>
            </div>

            <!-- 删除申请弹窗 -->
            <el-dialog title="删除申请" :visible.sync="deleteDialog" width="30%" center>
                <div>确定删除该征稿申请？</div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="onDelete">确 定</el-button>
                    <el-button @click="deleteDialog = false">取 消</el-button>
                </span>
            </el-dialog>

            <!-- 审核意见弹窗 -->
            <el-dialog title="审核意见" :visible.sync="opinionDialog" width="30%" center>
                 <el-input
                    type="textarea"
                    v-model="opinion"
                    :rows="4"
                    placeholder="请输入审核意见"
                 ></el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="opinionCheck">确 定</el-button>
                    <el-button @click="opinionDialog = false">取 消</el-button>
                </span>
            </el-dialog>

            <!-- 添加标记弹窗 -->
            <el-dialog title="标记申请" :visible.sync="addMarkDialog" width="30%" center>
                 <el-input
                    v-model="markContent"
                    placeholder="请输入标记"
                 ></el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="addMarkCheck">确 定</el-button>
                    <el-button @click="addMarkDialog = false">取 消</el-button>
                </span>
            </el-dialog>
        </div>  
    </div>
</template>

<script>
  import '@/assets/css/index.css';
  import $ from 'jquery'; 
  
  export default {
    data() {
      return {
        submitInfoListData:[],
        tableLoading: false,
        multipleSelectionTable: [],
        currentPage: 1,
        pageSize: 10,
        totalSize: 50,
        userData:"",
        searchFileForm:{},
        addTime:"",
        editTime:"",
        opinion:"",
        submitTime:"",
        markContent:"",
        // 弹窗
        deleteDialog: false,
        opinionDialog:false,
        addMarkDialog:false,
      }
    },
    mounted() {
        this.searchParam();
    },
    methods: {
        
        // 搜索
        onSearch() {
        this.searchParam();
        },
        // 加载数据
        searchParam() {
        let that = this;
        // let params = {};
          let params = Object.assign({}, this.searchFileForm);
        params.size = this.pageSize;
        params.page = this.currentPage;
        //   that.tableLoading = true;
        $.ajax({
            type: "GET",
            dataType: "json",
            url: "/zxzg/api/vh/common/act/submitInfo/list",
            data: params,
            // contentType: "application/json;charset=utf-8",
            success: function (response) {
            if (response.code == 200) {
                that.optionData = response.obj.list;
                if (response.obj.list && response.obj.list.length == 0) {
                that.dataText = "暂无数据";
                }
                // that.tableLoading = false;
                that.totalSize = response.obj.total;
                that.submitInfoListData = response.obj.list;
                that.currentPage = response.obj.pageNum;
            } else {
                that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            }
            },
            error: function (data) {
                console.log(data);
            },
        });
        },

        
        // 操作前确认
        preCheck(current) {
            let that = this;
            let ids = this.multipleSelectionTable.map((item) => {
                return item.id;
            });
            if (this.multipleSelectionTable.length == 0) {
                this.$message({
                message: "请选中具体的活动",
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            } else if (current == "toIn") {// 入选
                let flag = this.multipleSelectionTable.every(function (value) {
                if (value.status == 20) {
                    return true;
                }
                });
                if (flag) {
                    $.ajax({
                        url: "/zxzg/api/vh/common/act/submitInfo/audit",
                        type: "POST",
                        //contentType: 'application/json;charset=utf-8',
                        dataType: "json",
                        data: { ids: ids.toString(), toStatus : 40 },
                        error: function (xhr) {
                        this.onclick = true;
                        if (xhr.status == 401) {
                            window.location.reload();
                        }
                        },
                        success: function () {
                            that.$message({
                                message: "入选成功",
                                duration: 2000,
                                showClose: true,
                                type: "success",
                                offset: 100,
                            });
                            that.searchParam();
                        },
                    });
                } else {
                    this.$message({
                        message: "当前有申请为非审核通过状态，请通过审核后再进行入选操作",
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                }
            } else if (current == "toDelete") {// 删除确认
                let flag = this.multipleSelectionTable.every(function (value) {
                if (value.status == 10) {
                    return true;
                }
                });
                if (flag) {
                    this.deleteDialog = true;
                } else {
                    this.$message({
                        message: "当前有活动非禁用状态，请禁用后再进行删除操作",
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                }
            } else if (current == "toOn") {//审核通过
                $.ajax({
                    url: "/zxzg/api/vh/common/act/submitInfo/audit",
                    type: "POST",
                    //contentType: 'application/json;charset=utf-8',
                    dataType: "json",
                    data: { ids: ids.toString(), toStatus : 20 },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location.reload();
                        }
                    },
                    success: function (data) {
                        if (data.code == 200) {
                            that.$message({
                                message: "审核通过成功",
                                duration: 2000,
                                showClose: true,
                                type: "success",
                                offset: 100,
                            });
                            that.searchParam();                            
                        }else{
                            that.$message({
                                message: data.msg,
                                duration: 0,
                                showClose: true,
                                type: "error",
                                offset: 100,
                            });                            
                        }
                    },
                });
            } else if (current == "toOff") {//审核未通过
                this.opinionDialog = true;
            } else if (current == "toAddMark") {//添加标记
                this.addMarkDialog = true;
            }
        },
        
        // 删除
        onDelete() {
            let ids = this.multipleSelectionTable.map((item) => {
                return item.id;
            });
            let that = this;
            $.ajax({
                url: "/zxzg/api/vh/common/act/submitInfo/remove",
                type: "POST",
                //contentType: 'application/json;charset=utf-8',
                dataType: "json",
                data: { ids: ids.toString() },
                error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.reload();
                }
                },
                success: function (data) {
                    if (data.code == 200) {
                        that.$message({
                            message: "删除成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                        that.searchParam();
                        that.deleteDialog = false;
                    } else {
                        that.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error",
                            offset: 100,
                        });
                    }
                },
            });
        },

        // 分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.searchParam();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchParam();
        },
        
        // 选择表格某一行
        handleTableSelectionChange(val) {
        this.multipleSelectionTable = val;
        },
        // PDF预览
        preview(row) {
            let downloadA = document.createElement("a");
            let that = this;
            $.ajax({
                url: "/zxzg/api/vh/pdf/preview",
                type: "GET",
                data: {mregeId: row.id},
                contentType: "application/json;charset=utf-8",
                success: function (response) {
                    if (response.code == 200) {
                        downloadA.href = response.obj;
                        downloadA.download;
                        downloadA.click();
                    } else {
                        that.$message({
                            message: response.msg,
                            duration: 0,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                    }
                }
            });
        },
        
        // 数据导出
        SourceOut() {
            var exportForm = Object.assign({}, this.searchFileForm);
            var ids = this.multipleSelectionTable.map((item) => {
                return item.id;
            });
            var downloadA = document.createElement("a");
            var that = this;
            exportForm.ids = ids.toString();
            this.outDialog = true;
            $.ajax({
                url: "/zxzg/api/vh/submit/export",
                type: "GET",
                //contentType: 'application/json;charset=utf-8',
                data: exportForm,
                dataType: "json",
                error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.reload();
                }
                },
                success: function (data) {
                    if (data.code == 200) {
                        downloadA.href = data.obj;
                        downloadA.download;
                        downloadA.click();
                    }else{
                        that.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error" ,
                            offset: 100,
                        });
                    }
                },
            });
        },
        // 审核意见
        opinionCheck(){
            let that = this;
            let ids = this.multipleSelectionTable.map((item) => {
                return item.id;
            });
            if(this.opinion == null || this.opinion == ''){
                this.$message({
                    message: "请填写审核意见",
                    duration: 0,
                    showClose: true,
                    type: "error" ,
                    offset: 100,
                });
            }else{
                $.ajax({
                    url: "/zxzg/api/vh/common/act/submitInfo/audit",
                    type: "POST",
                    //contentType: 'application/json;charset=utf-8',
                    dataType: "json",
                    data: { 
                        ids: ids.toString(), 
                        toStatus : 30, 
                        opinion : this.opinion
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location.reload();
                        }
                    },
                    success: function (data) {
                        if (data.code == 200) {
                            that.$message({
                                message: "审核不通过意见提交成功",
                                duration: 2000,
                                showClose: true,
                                type: "success",
                                offset: 100,
                            });
                            that.searchParam();
                            that.opinionDialog = false;
                        }else{
                            that.$message({
                                message: data.msg,
                                duration: 0,
                                showClose: true,
                                type: "error" ,
                                offset: 100,
                            });
                        }
                    },
                });
            }
        },

        // 添加标记确认
        addMarkCheck(){
            let ids = this.multipleSelectionTable.map((item) => {
                return item.id;
            });
            let that = this;
            $.ajax({
                url: "/zxzg/api/vh/submit/mark",
                type: "POST",
                //contentType: 'application/json;charset=utf-8',
                dataType: "json",
                data: { 
                    ids: ids.toString(), 
                    mark : this.markContent
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                },
                success: function (data) {
                    if (data.code == 200) {
                        that.$message({
                            message: "标记成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                        that.searchParam();
                        that.addMarkDialog = false;
                    }else{
                        that.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error" ,
                            offset: 100,
                        });
                    }
                },
            });
        }
    }
  }
</script>

<style>
button.el-button--text {
    background-color: transparent;
    border-color: transparent;
    color: #4c5d65;
    font-size: 14px;
    font-weight: 700;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 5px;
}

</style>